"use client";

import { useAuth } from "@/lib/auth/AuthContext";

type AuthUser = {
  username: string | null;
  initial: string | null;
};

export function useAuthUser(): AuthUser {
  const { user } = useAuth();
  if (!user || user.scheme === "Bearer") return { username: null, initial: null };
  const username = user.username;
  if (!username) return { username: null, initial: null };
  return { username, initial: username.charAt(0).toUpperCase() };
}
